import { Box, Grid } from '@sequencehq/core-components'
import { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { CustomerOperatorSelect } from './CustomerOperatorSelect'

/**
 * Editor shown before a primary operator is picked: just the operator
 * dropdown. Picking INCLUDES / EXCLUDES / Custom property swaps in the
 * matching operator editor.
 */
export const NoOperatorEditor: ConditionPropertyEditorComponent = ({
  'data-testid': dataTestId,
  operator,
  onChange,
  operators,
  siblingConditions,
  validationErrors,
  focusOnInitialLoad
}) => {
  return (
    <Grid
      gridTemplateColumns="2fr 3fr"
      gap="8px"
      gridTemplateAreas='"operator ."'
    >
      <Box gridArea="operator">
        <CustomerOperatorSelect
          data-testid={dataTestId}
          operator={operator}
          operators={operators}
          siblingConditions={siblingConditions}
          onChange={onChange}
          validationErrors={validationErrors?.operator}
          initiallyOpen={focusOnInitialLoad}
        />
      </Box>
    </Grid>
  )
}
